export default (entityType) => {
	const map = {
		group: 'contactgroup',
		eventgoaloption: 'campaign/eventgoaloptions',
		template: 'email/template',
		user: 'account/user',
		customFormStat: 'customform',
	}

	return map[entityType] || entityType
}
